var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"nibnut-on-scroll",rawName:"v-nibnut-on-scroll:global",value:(_vm.scrolled),expression:"scrolled",arg:"global"}]},[_vm._t("default"),(_vm.page < _vm.nbPages)?_c('div',{staticClass:"text-center text-gray py-8"},[_vm._v(" "+_vm._s(_vm.$root.translate("Loading..."))+" ")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }